export enum DepositTypes {
	QUICK_DEPOSIT = 'QUICK_DEPOSIT',
	NORMAL_DEPOSIT = 'NORMAL_DEPOSIT',
	DEPOSIT_LOGIN = 'DEPOSIT_LOGIN',
	QUICK_DEPOSIT_SB = 'QUICK_DEPOSIT_SB',
	QUICK_DEPOSIT_GLOBAL = 'QUICK_DEPOSIT_GLOBAL'
}
